import createReactClass from 'create-react-class';
import React from 'react';
import PropTypes from 'prop-types';
import { PrintsBuilderUrlsShape } from '../prop-types';
import AddPhotosDevice from '../common/add-photos-device';
import genericHelpers from '../../_utils/generic-helpers';
import startSessionTimeout from '../../_utils/tools/session-timeout';
import PrintSizeFilter from './glass/print-size-filter';
import PhotoListView from './glass/photo-list-view';
import PhotoRemoveConfirmation from '../common/photo-remove-confirmation';
import PrintsBuilderMixin from '../common/prints-builder-mixin';
import SiteLogo from '../../_application/site-logo';
import SizeHelpers from '../common/size-helpers';
import Totaliser from '../common/totalizer';
import InvalidSizesModal from '../common/invalid-sizes-modal';
import InvalidDeliveryOptionModal from '../common/invalid-delivery-option-modal';
import UploadPhotosMixin from '../common/upload-photos-mixin';
import UploadProgressBar from '../common/upload-progress-bar';
import FullScreenSpinner from '../../_prism-builder/desktop/notices/full-screen-spinner';
import AdvancedEditor from '../common/advanced-editor';
import SummaryDropdown from './summary-dropdown';
import PhotoSelectionView from './glass/photo-selection-view';
import { allPhotosCollectedByRootImage } from '../common/collect-by-root-image';
import findRecommendedPrintSize from '../common/photo-quality/recommended-print-size';
import ScrollToTopBtn from './photos-grid/scroll-to-top-btn';
import PrintCountDisplay from './print-count-display';
import pluralize from '../../_utils/tools/pluralize';
import WithGestureActions from './with-gesture-actions';
import { sortedAndFilteredImages } from '../common/images-helper';
import { totalQuantity } from '../common/totalizing-mixin';
import Button from '../../_common/button';
import Footer from './footer';

const NewMobilePrintsBuilder = createReactClass({
  mixins: [PrintsBuilderMixin, UploadPhotosMixin],

  displayName: 'Mobile prints builder',

  getInitialState() {
    return {
      finish: {},
      delivery_option: {},
      sizes: [],
      showMultiSelectModal: false,
      selectedPhotoId: undefined,
      showScrollToTopBtn: false,
    };
  },

  _photoIDs: {},
  listWrapperRef: undefined,

  UNSAFE_componentWillMount() {
    this.loadData();

    // loader callbacks
    this.loadCallbacks();

    this._forceUpdate = genericHelpers.debounce(() => this.forceUpdate());
  },

  componentDidMount() {
    window.addEventListener('resize', this.handleViewportResize);
    window.addEventListener('orientationchange', this._forceUpdate);

    this.handleViewportResize();
    this.handleSessionTimeout();
  },

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleViewportResize);
    window.removeEventListener('orientationchange', this._forceUpdate);

    this.unloadCallbacks();
  },

  findAllRecommendedPrintSizes(availableSizes) {
    const { sizes } = this.state;
    const photosCollection = allPhotosCollectedByRootImage(sizes);

    return Object.entries(photosCollection).reduce(
      (acc, [id, photoSizes = {}]) => {
        const photo = (Object.values(photoSizes)[0] || [])[0];
        acc[id] = findRecommendedPrintSize(availableSizes, photo);
        return acc;
      },
      {}
    );
  },

  render() {
    const {
      delivery_option: deliveryOption,
      viewingSizeKey,
      currentlyLoading,
      finish,
      ready,
      invalidDeliveryOptionSelected,
      showMultiSelectModal,
      selectedPhotoId,
      showScrollToTopBtn,
    } = this.state;
    const {
      features: { allowMultiplePrintFinishesPerOrder },
      urls,
    } = this.props;

    // Keeps a record of the original order of prints
    Object.entries(allPhotosCollectedByRootImage(this.state.sizes)).forEach(
      ([id, size]) => {
        this._photoIDs[id] = Object.entries(size).map(
          ([, [photo]]) => photo.id
        );
      }
    );

    const availableSizes = this.availableSizesForSelectedDeliveryAndFinish();
    const sizes = this.state.sizes
      .filter(SizeHelpers.sizeHasPrints)
      .map(SizeHelpers.stripZeroQuantityPhotosFromSize);

    const sizesByFinish = this.getSizesByFinish().filter(
      SizeHelpers.sizeHasPrints
    );

    const hasPrints = this.hasPrints();
    const deliveryOptions = [...this.data.delivery_options];
    const finishes = [...this.data.finishes];
    const finishesByDeliveryOption = Object.assign(
      {},
      this.availableFinishesByDeliveryOption
    );
    const showGalleryView = hasPrints && !selectedPhotoId;
    const orderedPhotos = sortedAndFilteredImages({
      sizes,
      photoIds: this._photoIDs,
      viewingSizeKey,
      finish,
    });
    const recommendedPrintSizes = this.findAllRecommendedPrintSizes(
      availableSizes
    );
    const photos = SizeHelpers.augment.fromCollection(sizes);
    const selectedPhoto = selectedPhotoId
      ? photos.find(p => p.image_id === selectedPhotoId)
      : null;
    const selectedPhotoAssociatedPhotos = selectedPhoto
      ? photos.filter(p => p.root_image_id === selectedPhoto.root_image_id)
      : [];
    const photosLength = photos.length;
    const orderedPhotosLength = totalQuantity(orderedPhotos);
    const hasSelectedPhotoId = selectedPhotoId !== undefined;
    const displayAddPhotos = !currentlyLoading && orderedPhotosLength < 1;

    return (
      <div className="prints-builder__grid m-web mobile-builder__glass">
        <header className="prints-builder__header d-flex align-items-center">
          <div className="flex-grow-1">
            <SiteLogo />
          </div>
          <Totaliser sizes={sizes} deliveryOption={deliveryOption} />
        </header>
        <aside className="print-order__summary-and-filter">
          <SummaryDropdown
            allowMultiplePrintFinishesPerOrder={
              allowMultiplePrintFinishesPerOrder
            }
            basketUrl={urls.cart_page}
            addToCartEnabled={hasPrints && !currentlyLoading}
            handleAddToCart={this.handleAddToCart}
            deliveryOption={deliveryOption}
            deliveryOptions={deliveryOptions}
            finishesByDeliveryOption={finishesByDeliveryOption}
            finishes={finishes}
            finish={finish}
            handleOptionsChanged={this.handleOptionsChanged}
          />
          <UploadProgressBar {...currentlyLoading} />
          <InvalidSizesModal />
          <InvalidDeliveryOptionModal />
          {showGalleryView && (
            <div className="print-order__filter print-order__filter-border text-center">
              <PrintSizeFilter
                sizes={sizesByFinish}
                availableSizes={availableSizes}
                deliveryOption={deliveryOption}
                viewingSizeKey={viewingSizeKey}
                onChange={this.handleViewingSizeChanged}
                onResize={this.handleResize}
                generateSizeOptionLabel={size => size.title}
                hideLabelForAllSizes
              />
              {!!orderedPhotosLength && !hasSelectedPhotoId && (
                <PrintCountDisplay
                  classNames="prints-builder__m-web-print-count-display text-center"
                  selectedCount={
                    viewingSizeKey || allowMultiplePrintFinishesPerOrder
                      ? orderedPhotosLength
                      : photosLength
                  }
                  totalCount={photosLength}
                  text={pluralize('Print', photosLength)}
                  hideTotal={photosLength === 1}
                />
              )}
            </div>
          )}
        </aside>
        <main
          ref={ref => (this.listWrapperRef = ref)}
          className="prints-builder__list position-relative"
          onScroll={this.handleScroll}>
          <ScrollToTopBtn
            onClick={this.handleScrollToTop}
            showBtn={showScrollToTopBtn}
          />
          {!!orderedPhotosLength && hasSelectedPhotoId && (
            <WithGestureActions backGesture={this.setSelectedPhotoId}>
              <PhotoSelectionView
                selectedPhoto={selectedPhoto}
                selectedPhotoAssociatedPhotos={selectedPhotoAssociatedPhotos}
                setSelectedPhotoId={this.setSelectedPhotoId}
                availableSizes={availableSizes}
                deliveryOption={deliveryOption}
                onAdvancedEditPhoto={this.handleAdvancedEdit}
                sizes={sizesByFinish}
                viewingSizeKey={viewingSizeKey}
                orderedPhotos={orderedPhotos}
                recommendedPrintSizes={recommendedPrintSizes}
              />
            </WithGestureActions>
          )}
          {!!orderedPhotosLength && !hasSelectedPhotoId && (
            <PhotoListView
              availableSizes={availableSizes}
              deliveryOption={deliveryOption}
              onAdvancedEditPhoto={this.handleAdvancedEdit}
              sizes={sizesByFinish}
              orderedPhotos={orderedPhotos}
              viewingSizeKey={viewingSizeKey}
              handleSinglePhotoSelection={this.setSelectedPhotoId}
              recommendedPrintSizes={recommendedPrintSizes}
              showMultiSelectModal={showMultiSelectModal}
              handleShowMultiSelectModal={this.handleShowMultiSelectModal}
              invalidDeliveryOptionSelected={invalidDeliveryOptionSelected}
              hideSummaryDropdown={this.hideSummaryDropdown}
              handleAddPhotos={this.handleAddPhotos}
            />
          )}
          {displayAddPhotos && (
            <AddPhotosDevice
              onClick={this.handleAddPhotos}
              buttonClassName="btn-primary"
            />
          )}
        </main>
        {!hasPrints && (
          <Footer>
            <Button
              type="button"
              className="btn btn-outline-secondary mx-auto mt-2"
              onClick={this.handleAddPhotos}
              disabled={invalidDeliveryOptionSelected}
              text="Add More Photos"
            />
          </Footer>
        )}
        <AdvancedEditor
          ref={ref => (this.advancedEditorRef = ref)}
          availableSizes={availableSizes}
        />
        <PhotoRemoveConfirmation />
        <FullScreenSpinner show={!ready} />
      </div>
    );
  },

  addToCartEnabled() {
    return this.hasPrints() && !this.state.currentlyLoading;
  },

  handleShowMultiSelectModal() {
    this.hideSummaryDropdown();
    this.setState(prevState => ({
      showMultiSelectModal: !prevState.showMultiSelectModal,
    }));
  },

  handleViewportResize() {
    const vh = window.innerHeight * 0.01;
    genericHelpers.debounce(
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    );
  },

  handleAdvancedEdit(sizeKey, imageId) {
    const size = this.getSizeFromKey(sizeKey);
    const photo = SizeHelpers.augment.individual(
      this.getPhoto(size, imageId, true),
      size
    );

    this.advanced_edit = {
      size,
      photo,
    };

    this.advancedEditor().setData({
      photo,
      availableSizes: this.availableSizesForSelectedDeliveryAndFinish(),
      sizes: [...this.state.sizes],
    });
  },

  refreshEL2(sizeKey, imageId) {
    if (this.advanced_edit) {
      this.handleAdvancedEdit(sizeKey, imageId);
    }
  },

  handleSessionTimeout() {
    const { initSessionTimeout } = this.props;

    if (initSessionTimeout) {
      startSessionTimeout();
    }
  },

  handleScroll() {
    const { showScrollToTopBtn, selectedPhotoId } = this.state;
    const scrollOffsetHeight = 50;
    const scrollTop = this.listWrapperRef.scrollTop;

    if (selectedPhotoId) {
      this.setState({ showScrollToTopBtn: false });
      return;
    }

    if (scrollTop > scrollOffsetHeight && !showScrollToTopBtn) {
      this.hideSummaryDropdown();
      this.setState({ showScrollToTopBtn: true });
    }

    if (scrollTop < scrollOffsetHeight && showScrollToTopBtn) {
      this.setState({ showScrollToTopBtn: false });
    }
  },

  handleScrollToTop() {
    this.listWrapperRef.scrollTop = 0;
    this.setState({ showScrollToTopBtn: false });
  },

  allowZeroQuantity: () => false,

  setSelectedPhotoId(photoId) {
    this.hideSummaryDropdown();
    this.setState({ selectedPhotoId: photoId });
  },

  hideSummaryDropdown() {
    $('#summary-chart').collapse('hide');
  },
});

NewMobilePrintsBuilder.propTypes = {
  urls: PrintsBuilderUrlsShape.isRequired,
  features: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
  ),
  initSessionTimeout: PropTypes.bool,
  uploadFromGalleryListenerUrl: PropTypes.string,
};

NewMobilePrintsBuilder.defaultProps = {
  features: {},
  initSessionTimeout: false,
  uploadFromGalleryListenerUrl: '',
};

export default NewMobilePrintsBuilder;
